


































import { Toast } from "vant";
import { Component, Vue } from "vue-property-decorator";
import { getPhoneCode } from "@/req/login"
import NavBar from "./header.vue"
@Component({
  components: {
    NavBar
  }
})
export default class Logout extends Vue {
   // 表单效验规则
  public loginFormRules = {
            phone: [
              { required: true},
              { pattern: /^[\d]{6,11}$/ }
            ],
          }
  public passwordShow = false;
  public btnBgc = false;
  public flag = true;
  public formLogin = {
          phone: '',
          clause: true
        }

  public focus() {
    this.upKeyboard();
  }

  public upKeyboard() {
    if (!this.flag) return;
    const $password = (this.$refs.password as any);
    $password.style.height = $password.offsetHeight + "px";
    this.flag = false;
  }

  public async onSubmit() {
    if (!this.formLogin.clause) {
      Toast("请勾选下方用户协议");
      return;
    }
    const obj = {
      phone: this.formLogin.phone
    }
    const res = await getPhoneCode(obj);
    if (res.code === 200) {
      this.$router.push(
        { name: 'code', params: { phone: this.formLogin.phone, flag: "login" }}
      );
    } else {
      Toast(res.msg);
    }
  }

  public onChange() {
    if (this.formLogin.phone === "") {
        this.btnBgc = false;
    } else {
        this.btnBgc = true;
    }
  }
}
